import React, { useContext } from 'react';

const resultContext = React.createContext();
const resultUpdateContext = React.createContext();

export function useResult() {
   return useContext(resultContext);
}

export function useResultUpdate() {
    return useContext(resultUpdateContext)
}

export function ResultProvider({ children }) {

    const [result,setResult] = React.useState(0);
    const [resultID, setResultID] = React.useState(0);
    const [attempts, setAttempts] = React.useState(0);
    function setUserResult(_result) {
        setResult(_result);
    }
    function setUserResultID(_result) {
        setResultID(_result);
    }
    function setUserAttempts(_result) {
        setAttempts(_result);
    }
    
    return (

        <resultContext.Provider value={{"result": result, "resultid": resultID, "attempts": attempts}}>
            <resultUpdateContext.Provider value={{"setresult": setUserResult, "setuserresultid": setUserResultID, "setattempts": setUserAttempts}}>
                {children}
            </resultUpdateContext.Provider>
        </resultContext.Provider>

    )
}